import { combineReducers } from 'redux';

// TODO: not sure this function is currently achieving its intent
function sanityCheck(thingToCheck, storeType) {
  if (process.env.REACT_APP_API && process.env.REACT_APP_API.indexOf('ao.finalze.com') < 0) {
    // for (let key in thingToCheck) {
    if (typeof thingToCheck == 'object') {
      try {
        throw new Error('There is a non-normalized object being added to the store: ' + storeType);
      }
        catch (e) {
          //alert(e.message + window.sourceMappedStackTrace.mapStackTrace(e.stack))
        }
    }
    // }
  }
}

/**
 * This is used to maintain UI state for a given page/session.
 * E.g. scroll position, map zoom, etc
 */
function page_states(state={}, action) {
  switch(action.type) {
  case 'SET_PAGE_STATE':
    return Object.assign({}, state, {
      [action.pageName]: action.pageStateValue,
    }); 
  case 'SET_PAGE_STATE_ENTRY':
    const newState = Object.assign({}, state);
    if (!newState[action.pageName]) {
      newState[action.pageName] = {};
    }
    newState[action.pageName][action.entryKey] = action.entryValue;
    return newState;
  case 'RESET_PAGE_STATES':
    return {};
  default:
    return state;
  }
}

function main(state = {}, action) {
  switch (action.type) {
  case 'SET_CATASTROPHIC_ERROR':
    return Object.assign({}, state, {
      catastrophicError: action.catastrophicError,
    });
  case 'SET_DATA_MODEL':
    let model = Object.assign({}, state, {
      dataModel: action.dataModel,
      notificationsDataModel: action.dataModel.notificationsDataModel,
      referenceDocumentsDataModel: action.dataModel.referenceDocumentsDataModel,
      activityLogsDataModel: action.dataModel.activityLogsDataModel,
    });
    return model;
  case 'SET_HANDS_FREE_MODE':
    return Object.assign({}, state, {
      handsFreeMode: action.handsFreeMode,
    });
  case 'SET_NEEDS_LOGIN':
    return Object.assign({}, state, {
      needsLogin: true,
    });
  case 'SET_NEEDS_PARTIAL_LOGIN':
    return Object.assign({}, state, {
      needsPartialLogin: action.needsPartialLogin,
    });
  case 'SET_DISABLE_APP_BACKGROUND':
    return Object.assign({}, state, {
      disableAppBackground: action.disableAppBackground,
    });
  case 'SET_LOGIN_SUCCEEDED':
    return Object.assign({}, state, {
      needsLogin: false,
    });
  case 'SET_SESSION_TIMEOUT':
    return Object.assign({}, state, {
      sessionTimeout: action.sessionTimeout,
    });
  case 'SET_NAVIGATE_TO':
    return Object.assign({}, state, {
      navigateUri: action.navigateUri,
    });
  case 'SET_RETURN_URI':
    return Object.assign({}, state, {
      returnUri: action.returnUri,
    });
  case 'SET_PASSTHROUGH_URI':
    return Object.assign({}, state, {
      passthroughUri: action.passthroughUri,
    });
  case 'SET_INFO_ERROR_MESSAGE':
    return Object.assign({}, state, {
      infoErrorMessage: action.infoErrorMessage,
    });
  case 'DISMISS_INFO_ERROR_MESSAGE':
    return Object.assign({}, state, { infoErrorMessage: 'none' });

    //Global Modals/Popups
  case 'SHOW_MODAL':
    return Object.assign({}, state, {
      globalModal: {
        modalType: action.modalType,
        modalProps: action.modalProps,
      },
    });
  case 'HIDE_MODAL':
    return Object.assign({}, state, { 
      globalModal: {
        modalType: null,
        modalProps: {},
      },
    });

  case 'SHOW_CIRCLE_MODAL':
    return Object.assign({}, state, {
      circleGlobalModal: {
        modalType: action.modalType,
        modalProps: action.modalProps,
      },
    });
  case 'HIDE_CIRCLE_MODAL':
    return Object.assign({}, state, { 
      circleGlobalModal: {
        modalType: null,
        modalProps: {},
      },
    });
  
      //Global Banners
  case 'SHOW_BANNER':
    return Object.assign({}, state, {
      globalBanner: {
        bannerType: action.bannerType,
        bannerProps: action.bannerProps,
      },
    });
  case 'HIDE_BANNER':
    return Object.assign({}, state, { 
      globalBanner: {
        bannerType: action.bannerType,
        bannerProps: null,
      },
    });
  case 'CONNECTION_STATUS':
    return Object.assign({}, state, { 
      online: action.online,
    });
       //added to check connection problems separately
  case 'BAD_CONNECTION': 
    return Object.assign({}, state, { 
      badConnection: action.badConnection,
    });

  case 'DISPLAY_SYSTEM_POPUP':
    return Object.assign({}, state, { systemPopup: action.systemPopup });
  case 'DISMISS_SYSTEM_POPUP':
    return Object.assign({}, state, { systemPopup: null });

  case 'SET_SEARCH_RESULTS':
    return Object.assign({}, state, { results: action.results });
  case 'SET_IN_PROGRESS':
    return Object.assign({}, state, { inProgress: action.inProgress });
  case 'SET_DATA_CHANGED':
    return Object.assign({}, state, { dataChanged: action.dataChanged });
  case 'SET_ATTACHMENT_UPLOADING':
    return Object.assign({}, state, { attachmentUploading: action.attachmentUploading });
  case 'SET_REQUIRED_DATA_NOT_AVAILABLE':
    return Object.assign({}, state, { requiredDataNotAvailable: action.requiredDataNotAvailable });
  case 'SET_MOBILE_BRIDGE':
    return Object.assign({}, state, { mobileBridge: action.mobileBridge });
  case 'SET_MOBILE_RECEIPT':
    return Object.assign({}, state, {
      mobileReceipt: action.mobileReceipt,
    }); // mobileReceipt is { mobileAction: action, data: data}
    
  case 'ACTION_CABLE_UPDATE':
    return Object.assign({}, state, { actionCableUpdate: action.actionCableUpdate });
  case 'SET_BREADCRUMBS_PATH':
    return Object.assign({}, state, { breadCrumbsPath: action.breadCrumbsPath });
  default:
    return state;
  }
}

function new_vendor_companies(state = {}, action){
  switch (action.type){
  case 'VENDOR_COMPANY_SET':
    return Object.assign({}, state, { [action.vendor_company.id]: action.vendor_company });
  case 'VENDOR_COMPANY_UNSET':
    return Object.assign({}, state, { [action.vendor_company.id]: undefined });
  case 'VENDOR_COMPANY_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_company_vendor_users(state = {}, action){
  switch (action.type){
  case 'COMPANY_VENDOR_USER_SET':
    return Object.assign({}, state, { [action.company_vendor_user.id]: action.company_vendor_user });
  case 'COMPANY_VENDOR_USER_UNSET':
    return Object.assign({}, state, { [action.company_vendor_user.id]: undefined });
  case 'COMPANY_VENDOR_USER_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_vendor_users(state = {}, action){
  switch (action.type){
  case 'VENDOR_USER_SET':
    return Object.assign({}, state, { [action.company_vendor_user.id]: action.company_vendor_user });
  case 'VENDOR_USER_UNSET':
    return Object.assign({}, state, { [action.company_vendor_user.id]: undefined });
  case 'VENDOR_USER_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_market_users(state = {}, action){
  switch (action.type){
  case 'MARKET_USER_SET':
    return Object.assign({}, state, { [action.market_user.id]: action.market_user });
  case 'MARKET_USER_UNSET':
    return Object.assign({}, state, { [action.market_user.id]: undefined });
  case 'MARKET_USER_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_market_vendor_users(state = {}, action){
  switch (action.type){
  case 'MARKET_VENDOR_USER_SET':
    return Object.assign({}, state, { [action.market_vendor_user.id]: action.market_vendor_user });
  case 'MARKET_VENDOR_USER_UNSET':
    return Object.assign({}, state, { [action.market_vendor_user.id]: undefined });
  case 'MARKET_VENDOR_USER_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_company_closeout_templates(state = {}, action) {
  switch (action.type) {
  case 'COMPANY_CLOSEOUT_TEMPLATE_SET':
    sanityCheck(action.company_closeout_template, action.type);
    return Object.assign({}, state, { [action.company_closeout_template.id]: action.company_closeout_template });
  case 'COMPANY_CLOSEOUT_TEMPLATE_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'COMPANY_CLOSEOUT_TEMPLATE_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_closeout_templates(state = {}, action) {
  switch (action.type) {
  case 'CLOSEOUT_TEMPLATE_SET':
    sanityCheck(action.closeout_template, action.type);
    return Object.assign({}, state, { [action.closeout_template.id]: action.closeout_template });
  case 'CLOSEOUT_TEMPLATE_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'CLOSEOUT_TEMPLATE_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_closeouts(state = {}, action) {
  switch (action.type) {
  case 'CLOSEOUT_SET':
    sanityCheck(action.closeout, action.type);
    return Object.assign({}, state, { [action.closeout.id]: action.closeout });
  case 'CLOSEOUT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'CLOSEOUT_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_projects(state = {}, action) {
  switch (action.type) {
  case 'PROJECT_SET':
    sanityCheck(action.project, action.type);
    return Object.assign({}, state, { [action.project.id]: action.project });
  case 'PROJECT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'PROJECT_CLEAR':
    return {};
  case 'PROJECT_SUMMARY_SET':
    return Object.assign({}, state, { status_summary: action.projectsSummary });
  case 'PROJECT_SUMMARY_UNSET':
    return Object.assign({}, state, { status_summary: undefined });
  case 'PROJECT_SUMMARY_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_analysis_projects(state = {}, action) {
  switch (action.type) {
  case 'ANALYSIS_PROJECT_SET':
    sanityCheck(action.analysis_project, action.type);
    return Object.assign({}, state, { [action.analysis_project.id]: action.analysis_project });
  case 'ANALYSIS_PROJECT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'ANALYSIS_PROJECT_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_project_types(state = {}, action) {
  switch (action.type) {
  case 'PROJECT_TYPE_SET':
    sanityCheck(action.project, action.type);
    return Object.assign({}, state, { [action.project_type.id]: action.project_type });
  case 'PROJECT_TYPE_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'PROJECT_TYPE_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_project_templates(state = {}, action) {
  switch (action.type) {
  case 'PROJECT_TEMPLATE_SET':
    sanityCheck(action.project, action.type);
    return Object.assign({}, state, { [action.project_template.id]: action.project_template });
  case 'PROJECT_TEMPLATE_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'PROJECT_TEMPLATE_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_locations(state = {}, action) {
  switch (action.type) {
  case 'LOCATION_SET':
    return Object.assign({}, state, { [action.location.id]: action.location });
  case 'LOCATION_UNSET':
    if (action.location) {
      delete state[action.location.id];
    }
    return state;
  case 'LOCATION_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_location_users(state = {}, action) {
  switch (action.type) {
  case 'LOCATION_USER_SET':
    return Object.assign({}, state, { [action.location_user.id]: action.location_user });
  case 'LOCATION_USER_UNSET':
    if (action.location_user) {
      delete state[action.location_user.id];
    }
    return state;
  case 'LOCATION_USER_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_builds(state = {}, action) {
  switch (action.type) {
  case 'BUILD_SET':
    sanityCheck(action.project, action.type);
    return Object.assign({}, state, { [action.build.id]: action.build });
  case 'BUILD_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'BUILD_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_tasks(state = {}, action) {
  switch (action.type) {
  case 'TASK_SET':
    sanityCheck(action.project, action.type);
    return Object.assign({}, state, { [action.task.id]: action.task });
  case 'TASK_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'TASK_COUNTS_SET':
    return Object.assign({}, state, { task_counts: action.task_counts });
  case 'TASK_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_task_dependencies(state = {}, action) {
  switch (action.type) {
  case 'TASK_DEPENDENCY_SET':
    sanityCheck(action.project, action.type);
    return Object.assign({}, state, { [action.task_dependency.id]: action.task_dependency });
  case 'TASK_DEPENDENCY_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'TASK_DEPENDENCY_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_completion_criteria(state = {}, action) {
  switch (action.type) {
  case 'COMPLETION_CRITERION_SET':
    sanityCheck(action.project, action.type);
    return Object.assign({}, state, { [action.completion_criterion.id]: action.completion_criterion });
  case 'COMPLETION_CRITERION_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'COMPLETION_CRITERION_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_analysis_completion_criteria(state = {}, action) {
  switch (action.type) {
  case 'ANALYSIS_COMPLETION_CRITERION_SET':
    sanityCheck(action.analysis_completion_criterion, action.type);
    return Object.assign({}, state, { [action.analysis_completion_criterion.id]: action.analysis_completion_criterion });
  case 'ANALYSIS_COMPLETION_CRITERION_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'ANALYSIS_COMPLETION_CRITERION_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_delays(state = {}, action) {
  switch (action.type) {
  case 'DELAY_SET':
    return Object.assign({}, state, { [action.delay.id]: action.delay });
  case 'DELAY_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'DELAY_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_comments(state = {}, action) {
  switch (action.type) {
  case 'COMMENT_SET':
    return Object.assign({}, state, { [action.comment.id]: action.comment });
  case 'COMMENT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'COMMENT_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_conversions(state = {}, action){
  switch (action.type){
  case 'CONVERSION_SET':
    return Object.assign({}, state, { [action.conversion.id]: action.conversion });
  case 'CONVERSION_UNSET':
    return Object.assign({}, state, { [action.conversion.id]: undefined });
  case 'CONVERSION_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_markets(state = {}, action) {
  switch (action.type)   {
  case 'MARKET_SET': 
    return Object.assign({}, state, { [action.market.id]: action.market });
  case 'MARKET_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'MARKET_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_vendor_markets(state = {}, action){
  switch (action.type)   {
  case 'VENDOR_MARKET_SET': 
    return Object.assign({}, state, { [action.vendor_market.id]: action.vendor_market });
  case 'VENDOR_MARKET_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'VENDOR_MARKET_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_users(state = {}, action) {
  switch (action.type) {
  case 'USER_SET':
    return Object.assign({}, state, { [action.user.id]: action.user });
  case 'USER_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'USER_CLEAR':
    return {};
  case 'CURRENT_USER_SET':
    return Object.assign({}, state, { currentUser: action.currentUser });
  case 'PERMISSIONS_SET':
    return Object.assign({}, state, { permissions: action.permissions });
  case 'USER_ROLES_SET':
    return Object.assign({}, state, { userRoles: action.userRoles });
  case 'ADMIN_USER_ROLES_SET':
    return Object.assign({}, state, { adminUserRoles: action.adminUserRoles });
  case 'QUICK_ASSIGN_SET':
    return Object.assign({}, state, { quickAssignments: action.quickAssignments });
  default:
    return state;
  }
}

function new_roles(state = {}, action) {
  switch (action.type) {
  case 'ROLE_SET':
    return Object.assign({}, state, { [action.role.id]: action.role });
  case 'ROLE_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'ROLE_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_attachments(state = {}, action) {
  switch (action.type) {
  case 'ATTACHMENT_SET':
    return Object.assign({}, state, { [action.attachment.id]: action.attachment });
  case 'ATTACHMENT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'ATTACHMENT_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_event_histories(state = {}, action) {
  switch (action.type) {
  case 'EVENT_HISTORY_SET':
    return Object.assign({}, state, { [action.event_history.id]: action.event_history });
  case 'EVENT_HISTORY_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'EVENT_HISTORY_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_activities(state = {}, action) {
  switch (action.type) {
  case 'ACTIVITY_SET':
    return Object.assign({}, state, { [action.activity.id]: action.activity });
  case 'ACTIVITY_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'ACTIVITY_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_activity_sub_types(state = {}, action) {
  switch (action.type) {
  case 'ACTIVITY_SUB_TYPE_SET':
    return Object.assign({}, state, { [action.activity_sub_type.id]: action.activity_sub_type });
  case 'ACTIVITY_SUB_TYPE_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'ACTIVITY_SUB_TYPE_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_companies(state = {}, action) {
  switch (action.type) {
  case 'ADMIN_COMPANY_SET':
    return Object.assign({}, state, {
      adminCompany: action.adminCompany,
    });
  case 'COMPANY_SET':
    return Object.assign({}, state, { [action.company.id]: action.company });
  case 'COMPANY_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'COMPANY_CLEAR':
    return {};
  case 'CURRENT_COMPANY_SET':
    return Object.assign({}, state, {
      currentCompany: action.currentCompany,
    });
  default:
    return state;
  }
}

function new_directories(state = {}, action) {
  switch (action.type) {
  case 'DIRECTORY_SET':
    return Object.assign({}, state, { [action.directory.id]: action.directory });
  case 'DIRECTORY_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'DIRECTORY_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_project_users(state = {}, action) {
  switch (action.type) {
  case 'PROJECT_USER_SET':
    return Object.assign({}, state, { [action.project_user.id]: action.project_user });
  case 'PROJECT_USER_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'PROJECT_USER_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_project_contacts(state = {}, action) {
  switch (action.type) {
  case 'PROJECT_CONTACT_SET':
    return Object.assign({}, state, { [action.project_contact.id]: action.project_contact });
  case 'PROJECT_CONTACT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'PROJECT_CONTACT_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_user_task_assignments(state = {}, action) {
  switch (action.type) {
  case 'USER_TASK_ASSIGNMENT_SET':
    return Object.assign({}, state, { [action.user_task_assignment.id]: action.user_task_assignment });
  case 'USER_TASK_ASSIGNMENT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'USER_TASK_ASSIGNMENT_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_user_build_assignments(state = {}, action) {
  switch (action.type) {
  case 'USER_BUILD_ASSIGNMENT_SET':
    return Object.assign({}, state, { [action.user_build_assignment.id]: action.user_build_assignment });
  case 'USER_BUILD_ASSIGNMENT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'USER_BUILD_ASSIGNMENT_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_custom_project_settings(state = {}, action) {
  switch (action.type) {
  case 'CUSTOM_PROJECT_SETTING_SET':
    return Object.assign({}, state, { [action.custom_project_setting.id]: action.custom_project_setting });
  case 'CUSTOM_PROJECT_SETTING_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'CUSTOM_PROJECT_SETTING_CLEAR':
    return {};
  default:
    return state;
  }
}

function collections(state = {}, action) {
  switch (action.type) {
  case 'COLLECTION_SET':
    return Object.assign({}, state, { [action.key]: action.collection });
  case 'COLLECTION_UNSET':
    return Object.assign({}, state, { [action.key]: undefined });
  case 'COLLECTION_CLEAR':
    return {};
  default:
    return state;
  }
}

function notifications(state = {}, action) {
  switch (action.type) {
  case 'SET_NOTIFICATIONS':
    return Object.assign({}, state, { notifications: action.notifications });
  case 'SET_ALL_NOTIFICATIONS':
    return Object.assign({}, state, { allNotifications: action.allNotifications });
  case 'SET_CURRENT_NOTIFICATION':
    return Object.assign({}, state, { currentNotification: action.currentNotification });
  case 'SET_NOTIFICATION':
    let notification = {};
    notification['notification_' + action.notification.id] = { notification: action.notification };
    return Object.assign({}, state, notification);
  default:
    return state;
  }
}

function new_inventories(state = {}, action) {
  switch(action.type) {
  case 'INVENTORY_SET':
    return Object.assign({}, state, { [action.inventory.id]: action.inventory });
  case 'INVENTORY_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'INVENTORY_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_inventory_items(state = {}, action) {
  switch(action.type) {
  case 'INVENTORY_ITEM_SET':
    return Object.assign({}, state, { [action.inventory_item.id]: action.inventory_item });
  case 'INVENTORY_ITEM_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'INVENTORY_ITEM_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_reference_documents(state = {}, action) {
  switch (action.type) {
  case 'REFERENCE_DOCUMENT_SET':
    return Object.assign({}, state, { [action.reference_document.id]: action.reference_document });
  case 'REFERENCE_DOCUMENT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'REFERENCE_DOCUMENT_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_unique_documents(state = {}, action) {
  switch (action.type) {
  case 'UNIQUE_DOCUMENT_SET':
    return Object.assign({}, state, { [action.unique_document.id]: action.unique_document });
  case 'UNIQUE_DOCUMENT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'UNIQUE_DOCUMENT_CLEAR':
    return {};
  default:
    return state;
  }
}

function referenceDocuments(state = {}, action) {
  switch (action.type) {
  case 'SET_REFERENCE_DOCUMENTS':
    if (isNaN(action.lastReferenceDocumentsPage)) {
      return Object.assign({}, state, {
        referenceDocuments: action.referenceDocuments,
      });
    }
    else {
      return Object.assign({}, state, {
        referenceDocuments: action.referenceDocuments,
        lastReferenceDocumentsPage: parseInt(action.lastReferenceDocumentsPage, 10),
        totalReferenceDocuments: parseInt(action.totalReferenceDocuments, 10),
      });
    }
  case 'SET_REFERENCE_DOCUMENT':
    let referenceDocument = {};
    referenceDocument['reference_document_' + action.referenceDocument.id] = { referenceDocument: action.referenceDocument };
    return Object.assign({}, state, referenceDocument);
  case 'SET_REFERENCE_DOCUMENTS_GROUP':
    let groupIdentifier = {};
    groupIdentifier['group_identifier_' + action.id] = { 
      groupedReferenceDocuments: action.referenceDocuments,
    };
    return Object.assign({}, state, groupIdentifier);
  default:
    return state;
  }
}

function activityLogs(state = {}, action) {
  switch(action.type) {
  case 'SET_ACTIVITIES_LIST':
    return Object.assign({}, state, {
      activitiesList: action.activitiesList,
    });
  case 'SET_EVENT_HISTORIES':
    if (isNaN(action.lastEventHistoriesPage)) {
      return Object.assign({}, state, {
        eventHistories: action.eventHistories,
      });
    }
    else{
      return Object.assign({}, state, {
        eventHistories: action.eventHistories,
        lastEventHistoriesPage: action.lastEventHistoriesPage,
        totalEventHistories: action.totalEventHistories,
      });
    }
  default:
    return state;
  }
}

function activities(state = {}, action) {
  switch(action.type) {
  case 'ACTIVITIES_SET':
    return Object.assign({}, state, action.activities);
  case 'ACTIVITIES_CLEAR':
    return {};
  default:
    return state;
  }
}

function activity_sub_types(state = {}, action) {
  switch(action.type) {
  case 'ACTIVITY_SUB_TYPES_SET':
    return Object.assign({}, state, action.activity_sub_types);
  case 'ACTIVITY_SUB_TYPES_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_main(state = { user_id: 0, store_version: 1 }, action) {
  switch (action.type) {
  case 'MAIN_SET_USER':
    return Object.assign({}, state, { user_id: action.user_id });
  case 'MAIN_SET_VERSION':
    return Object.assign({}, state, { store_version: action.store_version });
  default:
    return state;
  }
}

function new_form_fields(state = {}, action) {
  switch (action.type) {
  case 'FORM_FIELD_SET':
    return Object.assign({}, state, { [action.form_field.id]: action.form_field });   
  case 'FORM_FIELD_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_customers(state = {}, action) {
  switch (action.type) {
  case 'CUSTOMER_SET':
    return Object.assign({}, state, { [action.customer.id]: action.customer });   
  case 'CUSTOMER_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'CUSTOMER_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_teams(state = {}, action) {
  switch (action.type) {
  case 'TEAM_SET':
    return Object.assign({}, state, { [action.team.id]: action.team });   
  case 'TEAM_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'TEAM_CLEAR':
    return {};
  default:
    return state;
  }
}

function new_announcements(state = {}, action) {
  switch (action.type) {
  case 'ANNOUNCEMENT_SET':
    return Object.assign({}, state, { [action.announcement.id]: action.announcement });   
  case 'ANNOUNCEMENT_UNSET':
    return Object.assign({}, state, { [action.id]: undefined });
  case 'ANNOUNCEMENT_CLEAR':
    return {};
  default:
    return state;
  }
}

function analytics(state = {}, action) {
  switch (action.type) {
  case 'SET_ANALYTICS_OBJECT':
    return Object.assign({}, state, { [action.objectKey]: action.newObjectValue });
  case 'RESET_ANALYTICS':
    return {};
  default:
    return state;
  }
}

import React from 'react';
import { isArray } from 'lodash';

const USER_DIRECTORY_ACTIONS = {
  SET_USERS_LIST: 'SET_USERS_LIST/USER_DIRECTORY',
  SET_FETCHING: 'SET_FETCHING',
  SET_SEARCH_USERS_LIST: 'SET_SEARCH_USERS_LIST',
  SET_FILTERED_USERS_LIST: 'SET_FILTERED_USERS_LIST',
  RESET_USER_STATE: 'RESET_USER_STATE',
};

const initialState = {
  usersList: [],
  isFetching: false,
  searchUsersList: [],
  totalUsers: 0,
  totalSearchUsers: null,
  filteredUsers: [],
  pageNumber: 0,
};

export const setUsersList = (data) => {
  return {
    type: USER_DIRECTORY_ACTIONS.SET_USERS_LIST,
    data,
  };
};

export const setSearchUsersList = (data) => {
  return {
    type: USER_DIRECTORY_ACTIONS.SET_SEARCH_USERS_LIST,
    data,
  };
};

export const setFetchingState = (data) => {
  return {
    type: USER_DIRECTORY_ACTIONS.SET_FETCHING,
    data,
  };
};

export const setFilteredUsers = (data) => {
  return {
    type: USER_DIRECTORY_ACTIONS.SET_FILTERED_USERS_LIST,
    data,
  };
};

export const resetUserState = () => {
  return {
    type: USER_DIRECTORY_ACTIONS.RESET_USER_STATE,
  };
};

const getKeyType = (keyType) => {
  switch(keyType){
  case 'company':
    return 'companies';
  case 'directory':
    return 'directories';
  case 'market':
    return 'markets';
  default:
    return keyType;
  }
};

export const normalizeData = (response) => {
  let includedData = {};
  if(response.included){
    response.included.map(item => {
      if(!includedData[item.type]){
        includedData = { ...includedData, [item.type]: {} };
      }
      includedData = {
        ...includedData,
        [item.type]: {
          ...includedData[item.type],
          [item.id]: {
            ...item.attributes,
            id: item.id,
          },
        },
      };
    });
  }
  return response.data.map(item => {
    let otherData = {};
    Object.keys(item.relationships).map(key => {
      let obj = item.relationships[key];
      let keyName = getKeyType(obj.data.type);
      if(!isArray(obj.data) && keyName == 'markets'){
        otherData = {
          ...otherData,
          [keyName]: [{
            ...includedData[obj.data.type][obj.data.id],
          }],
        };
      }
      else if(!isArray(obj.data)){
        otherData = {
          ...otherData,
          [keyName]: {
            ...includedData[obj.data.type][obj.data.id],
          },
        };
      }else{
        obj.data.map(itr => {
          let keyName = getKeyType(itr.type);
          let temp = [{
            ...itr,
            ...includedData[itr.type][itr.id],
          }];
          let data = otherData[keyName] ? otherData[keyName].concat(temp) : temp;
          otherData = {
            ...otherData,
            [keyName]: data,
          };
        });
      }
    });
    return {
      ...item.attributes,
      id: item.id,
      ...otherData,
    };
  });
};

export const userState = (state = initialState, action) => {
  switch(action.type){
  case USER_DIRECTORY_ACTIONS.SET_USERS_LIST:
    if(!action.data) return state;
    let normalizedUsers = normalizeData(action.data);
    return {
      ...state,
      usersList: Number(action.data.meta.last_page) == 1 ? normalizedUsers : state.usersList.concat(normalizedUsers),
      pageNumber: Number(action.data.meta.last_page),
      totalUsers: Number(action.data.meta.last_page) > 1 && normalizedUsers.length == 0 ?  state.usersList.length : Number(action.data.meta.total_records),
    };
  case USER_DIRECTORY_ACTIONS.SET_SEARCH_USERS_LIST:
    let normalizedSearchUsers = normalizeData(action.data);
    return {
      ...state,
      searchUsersList: normalizedSearchUsers,
    };
  case USER_DIRECTORY_ACTIONS.SET_FETCHING:
    return {
      ...state,
      isFetching: action.data,
    };
  case USER_DIRECTORY_ACTIONS.SET_FILTERED_USERS_LIST:
    return {
      ...state,
      filteredUsers: action.data,
      totalUsers: action.data.length,
    };
  case USER_DIRECTORY_ACTIONS.RESET_USER_STATE:
    return {
      ...state,
      ...initialState,
    };
  default:
    return state;
  }
};

const reducers = combineReducers({
  main,
  notifications,
  referenceDocuments,
  activityLogs,
  activities,
  activity_sub_types,
  // refactored data store starts here!
  new_project_types,
  new_projects,
  new_analysis_projects, //************ Need daos for resetting store */
  new_project_templates,
  new_builds,
  new_tasks,
  new_task_dependencies,
  new_reference_documents,
  new_unique_documents, //************* Need daos for resetting store */
  new_users,
  new_conversions,
  new_markets,
  new_vendor_markets, //************** Need daos for resetting store */
  new_market_users, //************** Need daos for resetting store */
  new_market_vendor_users, //************* Need daos for resetting store */
  new_locations,
  new_location_users,
  new_roles,
  new_completion_criteria,
  new_analysis_completion_criteria, //**************** Need daos for resetting store */
  new_attachments,
  new_event_histories,
  new_activities, //******************* Need daos for resetting store */
  new_activity_sub_types, //***************** Need daos for resetting store */
  new_companies,
  new_vendor_companies,
  new_directories,
  new_project_users,
  new_project_contacts,
  new_user_task_assignments,
  new_user_build_assignments,
  new_custom_project_settings,
  new_delays,
  new_comments,
  new_company_vendor_users,
  new_vendor_users,
  new_company_closeout_templates, //******************** Need daos for resetting store */
  new_closeout_templates, //********************* Need daos for resetting store */
  new_closeouts, //****************** Need daos for resetting store */
  new_inventories,
  new_inventory_items,
  collections,
  new_form_fields, //******************* Need daos for resetting store */
  new_customers,
  new_teams,
  new_announcements,
  new_main,
  page_states,
  analytics,
  userState,
});

const rootReducer = (state, action) => {
  if (action.type == 'USER_LOGOUT') {
    return reducers(undefined, action);
  }

  return reducers(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/models/index.js